<template>
  <button-base :channel="channel" :show-button-labels="showButtonLabels" icon-class="icon-x-twitter"
               @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import TwitterMixin from '@/share/campaign/twitter-mixin'

export default {
  components: { ButtonBase },

  mixins: [TwitterMixin],

  props: {
    channel: {
      type: Object,
      required: true
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    }
  }
}
</script>
